import { useState } from 'react'
import { gql } from '@apollo/client'
import { BREAKPOINT, useIsMobileResolution } from '@npco/zeller-design-system'
import { useFeatureFlags } from 'features/FeatureFlags'

import { useImagePreloader } from 'hooks/useImagePreloader/useImagePreloader'

import {
  SavingsStartupDebitCardAccountV2Fragment,
  SavingsStartupEntityFragment,
} from './SavingsStartup.generated'
import { getSavingsStartupImage } from './SavingsStartup.utils'
import { SavingsStartupModal } from './SavingsStartupModal'

type SavingsStartupProps = {
  savingsAccount: SavingsStartupDebitCardAccountV2Fragment | null
  entity: SavingsStartupEntityFragment
}

export const SavingsStartup = ({
  savingsAccount,
  entity,
}: SavingsStartupProps) => {
  const isMobile = useIsMobileResolution()
  const isMobileOrTablet = useIsMobileResolution(BREAKPOINT.MD)

  const flags = useFeatureFlags()

  const { imagesPreloaded } = useImagePreloader(
    getSavingsStartupImage({
      isMobile,
      isMobileOrTablet,
      isSavingsAccountMarchFeatureFlagOn: flags.SavingsAccountMarch,
    })
  )

  const [isOpen, setIsOpen] = useState(true)

  return (
    <>
      {entity.savingsAccountProduct && imagesPreloaded && (
        <SavingsStartupModal
          savingsAccount={savingsAccount}
          entity={entity}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )}
    </>
  )
}

SavingsStartup.fragments = {
  Entity: gql`
    fragment SavingsStartupEntityFragment on Entity {
      ...SavingsStartupModalEntityFragment
    }

    ${SavingsStartupModal.fragments.Entity}
  `,
  DebitCardAccountV2: gql`
    fragment SavingsStartupDebitCardAccountV2Fragment on DebitCardAccountV2 {
      ...SavingsStartupModalDebitCardAccountV2Fragment
    }

    ${SavingsStartupModal.fragments.DebitCardAccountV2}
  `,
}
